import actions from './actions';
import mutations from './mutations';
import getters from './getters';

function state() {
    return {
        editorDialogOpen: false,
        editorIsPreview: false,
        editorDialogSilentOpen: false,
        imageGalleryOpen: false,

        loading: {
            imageGallery: false,
            form: false
        },

        selectDialogOpen: false,
        previewDialogOpen: false,
        cloneMediaObjectId: null,
        cloneMediaObject: null,

        cloneDialogOpen: false,
        isSaving: false,

        formData: {
            id: null,
            content: '',
            content_id: null,
            website_id: null
        },

        images: [],

        cloneFormData: {
            mediaId: 0,
            assetName: '',
            cloneMediaSettings: "0",
            cloneAccessSettings: "0"
        },

        aceEditor: null,
        hasChanges: false,

        activeTab: 'blocks',

        // array of grape components matching '.te-page'
        pages: [],
        activePage: null,

        comarketableContent: false,

        hasPage: true,
        hasSectionContainer: true
    };
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};